// grabs tab info in localStorage to keep selected tab even on refresh
// navigating any menu in the sidebar removes tab from localstorage
export const cachedTab = () => {
  return JSON.parse(localStorage.getItem("tab"))?.replace(/"/g, "");
};
